export interface DeliveryDate {
  nextDayDelivery: boolean;
  defaultLeadTime: boolean;
  deliveryDate: Date;
  deliveryPeriodId: string;
  deliveryMonthId: string;
  deliveryWeek: number;
  deliveryYear: number;
}
